import {
  REPORT_COLUMNS_LIBRARY_REQUEST,
  REPORT_COLUMNS_LIBRARY_SUCCESS,
  REPORT_COLUMNS_LIBRARY_FALIURE,
  REPORT_COLUMNS_REQUEST,
  REPORT_COLUMNS_SUCCESS,
  REPORT_COLUMNS_FALIURE,
  UPDATE_REPORT_COLUMNS_REQUEST,
  UPDATE_REPORT_COLUMNS_SUCCESS,
  UPDATE_REPORT_COLUMNS_FALIURE,
  DELETE_REPORT_COLUMN_REQUEST,
  DELETE_REPORT_COLUMN_SUCCESS,
  DELETE_REPORT_COLUMN_FALIURE
} from './ReportsConstants'
import {config} from '../config'
import toast from 'react-hot-toast'

export const reportColumnsLibraryRequest = (report_columns_library_request) =>{
  return{
    type : REPORT_COLUMNS_LIBRARY_REQUEST,
    payload : report_columns_library_request
  }
}

export const reportColumnsLibrarySuccess = (report_columns_library_success) =>{
  return{
    type : REPORT_COLUMNS_LIBRARY_SUCCESS,
    payload : report_columns_library_success
  }
}

export const reportColumnsLibraryFaliure = (report_columns_library_faliure) =>{
  return{
    type : REPORT_COLUMNS_LIBRARY_FALIURE,
    payload : report_columns_library_faliure
  }
}

export const reportColumnsRequest = (report_columns_request) =>{
  return{
    type : REPORT_COLUMNS_REQUEST,
    payload : report_columns_request
  }
}

export const reportColumnsSuccess = (report_columns_success) =>{
  return{
    type : REPORT_COLUMNS_SUCCESS,
    payload : report_columns_success
  }
}

export const reportColumnsFaliure = (report_columns_faliure) =>{
  return{
    type : REPORT_COLUMNS_FALIURE,
    payload : report_columns_faliure
  }
}

export const updateReportColumnsRequest = (report_columns_request) =>{
  return{
    type : UPDATE_REPORT_COLUMNS_REQUEST,
    payload : report_columns_request
  }
}

export const updateReportColumnsSuccess = (report_columns_success) =>{
  return{
    type : UPDATE_REPORT_COLUMNS_SUCCESS,
    payload : report_columns_success
  }
}

export const updateReportColumnsFaliure = (report_columns_faliure) =>{
  return{
    type : UPDATE_REPORT_COLUMNS_FALIURE,
    payload : report_columns_faliure
  }
}

export const deleteReportColumnRequest = (report_column_request) =>{
  return{
    type : DELETE_REPORT_COLUMN_REQUEST,
    payload : report_column_request
  }
}

export const deleteReportColumnSuccess = (report_column_success) =>{
  return{
    type : DELETE_REPORT_COLUMN_SUCCESS,
    payload : report_column_success
  }
}

export const deleteReportColumnFaliure = (report_column_faliure, columnId) =>{
  return{
    type : DELETE_REPORT_COLUMN_FALIURE,
    payload : report_column_faliure,
    columnId : columnId
  }
}

export const fetchReportColumnsLibrary = (report_columns_library) =>{
    return(dispatch) => {
      dispatch(reportColumnsLibraryRequest(report_columns_library))
      const url =`${config.api_root}/api/v1/merchants/report_columns_library?user_id=${config.user_id}`;
      const request_option = {
      method: "GET",
      headers: {
              'Accept': 'application/json',
              'Authorization': 'Bearer '+ config.token,
              'Content-Type': 'application/json'
          }
    }
    fetch(url, request_option)
    .then(response => response.json())
    .then(report_columns_library_res =>{
      const report_columns_library_success = report_columns_library_res
      if(report_columns_library_success.request_status === true){
        dispatch(reportColumnsLibrarySuccess(report_columns_library_success))
      } else {
        toast.error(report_columns_library_res.object.error)
      }
    })
    .catch(error => {
      const errorMsg = error
      dispatch(reportColumnsLibraryFaliure(errorMsg))
    })
    }
}

export const fetchReportColumns = (report_columns) =>{
    return(dispatch) => {
      dispatch(reportColumnsRequest(report_columns))
      const url =`${config.api_root}/api/v1/merchants/report_columns?user_id=${config.user_id}`;
      const request_option = {
      method: "GET",
      headers: {
              'Accept': 'application/json',
              'Authorization': 'Bearer '+ config.token,
              'Content-Type': 'application/json'
          }
    }
    fetch(url, request_option)
    .then(response => response.json())
    .then(report_columns_res =>{
      const report_columns_success = report_columns_res
      if(report_columns_success.request_status === true){
        dispatch(reportColumnsSuccess(report_columns_success))
      } else {
        toast.error(report_columns_res.object.error)
      }
    })
    .catch(error => {
      const errorMsg = error
      dispatch(reportColumnsFaliure(errorMsg))
    })
    }
}

export const deleteReportColumn = (updateCode, columnId) =>{
    return(dispatch) => {
      dispatch(deleteReportColumnRequest(columnId))
      const url =`${config.api_root}/api/v1/merchants/report_columns?update_code=${updateCode}&column_id=${columnId}`;
      const request_option = {
      method: "DELETE",
      headers: {
              'Accept': 'application/json',
              'Authorization': 'Bearer '+ config.token,
              'Content-Type': 'application/json'
          }
    }
    fetch(url, request_option)
    .then(response => response.json())
    .then(report_columns_res =>{
      const report_columns_success = report_columns_res
      if(report_columns_success.request_status === true){
        dispatch(deleteReportColumnSuccess(report_columns_success))
      } else {
        dispatch(deleteReportColumnFaliure(report_columns_success, columnId));
      }
    })
    .catch(error => {
      const errorMsg = error
      dispatch(deleteReportColumnFaliure(errorMsg, columnId))
    })
    }
}


export const updateReportColumns = (report_column_list, updateCode) =>{
    return(dispatch) => {
      dispatch(updateReportColumnsRequest(updateCode))
      const url =`${config.api_root}/api/v1/merchants/report_columns?update_code=${updateCode}`;
      const request_option = {
      method: "POST",
      headers: {
              'Accept': 'application/json',
              'Authorization': 'Bearer '+ config.token,
              'Content-Type': 'application/json'
          },
      body: JSON.stringify({
         user_id : config.user_id,
         fields : report_column_list,
      })
    }
    fetch(url, request_option)
    .then(response => response.json())
    .then(report_columns_success =>{
      if(report_columns_success.request_status === true){
         dispatch(updateReportColumnsSuccess(report_columns_success))
      } else {
         dispatch(updateReportColumnsFaliure(report_columns_success));
        //  toast.error(report_columns_success.object.error)
      }
    })
    .catch(error => {
      const errorMsg = error
      dispatch(updateReportColumnsFaliure(errorMsg))
    })
    }
}


